export default __webpack_public_path__ + "static/column-offset-dark-4650290a6e9e7c5cf33b3cb6cf1f770943e44644eeffca2f21ea52054a6ab95d.png";